import React from "react";

const Allergies=()=>{

    return(
        <>
        </>
    )
}

export default Allergies